module.exports = __webpack_public_path__ + "static/media/Icn-com.f6589fb8.svg";